module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1017-baf8dda7fd5c8962b5ce6f583c087a42.png";